export const ORDER_STATUS = {
  PENDING: 'pending', // 待支付
  SUCCESS: 'success', // 已支付
  FAILED: 'failed', // 已失败
  CANCELLED: 'cancelled', // 已取消
  CLOSED: 'closed', // 已关闭
  DELETED: 'deleted', // 已删除
};

export const ORDER_STATUS_MAP: Record<string, { text: string; color: string }> =
  {
    [ORDER_STATUS.PENDING]: { text: '待支付', color: 'default' },
    [ORDER_STATUS.SUCCESS]: { text: '已支付', color: 'success' },
    [ORDER_STATUS.FAILED]: { text: '已失败', color: 'error' },
    [ORDER_STATUS.CANCELLED]: { text: '已取消', color: 'error' },
    [ORDER_STATUS.CLOSED]: { text: '已关闭', color: 'default' },
    [ORDER_STATUS.DELETED]: { text: '已删除', color: 'default' },
  };

// 用于在详情页面中获取状态文本和颜色的辅助函数
export const getOrderStatusInfo = (status: string) => {
  return ORDER_STATUS_MAP[status] || { text: '未知', color: 'default' };
};

export const ORDER_TYPE = {
  PRESET: 'preset', // 预配置
  CONSUME: 'consume', // 用户消费
  RECHARGE: 'recharge', // 用户充值
};

export const ORDER_TYPE_MAP: Record<string, string> = {
  [ORDER_TYPE.PRESET]: '预配置',
  [ORDER_TYPE.CONSUME]: '用户消费',
  [ORDER_TYPE.RECHARGE]: '用户充值',
};

/**
 * 注册来源枚举
 * 对应后端 API 返回的 source 值
 */
export enum SourceEnum {
  Api = 'api',
  App = 'app',
  Wap = 'wap',
  Www = 'www',
  Web = 'web',
}

/**
 * 注册/订单来源选项
 * 用于表单下拉框
 */
export const SOURCE_VALUE_ENUM: Record<string, string> = {
  [SourceEnum.Api]: 'API',
  [SourceEnum.App]: 'APP',
  [SourceEnum.Wap]: 'WAP',
  [SourceEnum.Www]: '官网',
  [SourceEnum.Web]: '后台',
};

/**
 * 获取注册/订单来源文本
 * @param source 来源值
 * @returns 来源文本，如果不存在则返回 '-'
 */
export const getSourceText = (source: string | null | undefined): string => {
  if (!source) return '-';
  return SOURCE_VALUE_ENUM[source] || '-';
};
